import template from './pipeline.html';
import controller from './pipelineCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isSmallDevice: '<',
  },
};
